import { PropsWithChildren, useCallback } from "react";
import { Stack } from "@fluentui/react/lib/Stack";

import { WithTranslator } from "Components/Generic/Translator";
import { CustomPanel, CustomPanelSizeType } from "Components/Generic/CustomPanel";
import { useDialogStyles } from "./UseDialogStyles";
import { IDialogProps } from "./IDialogProps";
import { useSelectedProjects } from "./UseSelectedProjects";
import { Navigation } from "./Navigation";
import { Progress } from "./Progress";
import { WithProjectItemContext } from "../ProjectItemContext/WithProjectItemContext";
import { DialogType } from "./DialogType";

export const Dialog = WithProjectItemContext(
  WithTranslator((props: PropsWithChildren<IDialogProps>): JSX.Element => {
    const {
      isOpen, onDismiss, onSave, children, type, translator
    } = props;
    const styles = useDialogStyles();

    const {
      project, progress, isLastProject, isMultiProject, onNextProject
    } = useSelectedProjects();

    const onSaveCloseProject = useCallback(() => {
      onDismiss();
      onSave();
    }, [onDismiss, onSave]);

    const onSaveNextProject = useCallback(() => {
      onSave();
      onNextProject();
    }, [onNextProject, onSave]);

    return (
      <CustomPanel
        customPanelSize={CustomPanelSizeType.large}
        isOpen={isOpen}
        onDismiss={onDismiss}
        isLightDismiss
        onButtonClick={isMultiProject && !isLastProject ? onSaveNextProject : onSaveCloseProject}
        buttonText={
          isMultiProject && !isLastProject
            ? translator.get(`generic.savenext`, `Save & Next`)
            : translator.get(`generic.saveclose`, `Save & Close`)
        }
        buttonIcon="SaveAndClose"
        headerTitle={
          type === DialogType.AddressValidation
            ? translator.get(`av`, `Address Validation`)
            : translator.get(`dc`, `Duplicate Check`)
        }
      >
        <Stack grow className={styles.root}>
          <Stack grow horizontal className={styles.mainRoot}>
            <Navigation project={project} />
            <Stack grow disableShrink className={styles.contentRoot}>
              <Stack.Item grow className={styles.content}>
                {children}
              </Stack.Item>
            </Stack>
          </Stack>
          <Progress progress={progress} />
        </Stack>
      </CustomPanel>
    );
  })
);
